import { type FC, type ReactNode, useId } from 'react'
import { Dropdown } from 'react-bootstrap'
import classNames from 'classnames'
import { getIntegrationDisplayName, type IntegrationServiceId } from '../../../../../common/integrations'
import { Button } from '../../../../../components/Button/Button'

interface ParticipantIntegrationMenuProps {
  serviceId: IntegrationServiceId
  disabled?: boolean
  onUpdateContact: () => void
  onManageWorkflows: () => void
  children: ReactNode
}

interface MenuItemProps {
  icon: string
  title: string
  description: string
  onClick: () => void
}

const MenuItem: FC<MenuItemProps> = ({ icon, title, description, onClick }) => (
  <Dropdown.Item onClick={onClick} className='d-flex align-items-start gap-2 p-3'>
    <i className={classNames('bi', icon)} />
    <span className='d-flex flex-column'>
      <span className='paragraph-medium zocks-text-gray-900'>{title}</span>
      <span className='paragraph-small zocks-text-gray-600'>{description}</span>
    </span>
  </Dropdown.Item>
)

export const ParticipantIntegrationMenu: FC<ParticipantIntegrationMenuProps> = ({ serviceId, disabled, onUpdateContact, onManageWorkflows, children }) => {
  const toggleId = useId()
  const integrationName = getIntegrationDisplayName(serviceId)

  return (
    <Dropdown>
      <Dropdown.Toggle
        as={Button}
        id={toggleId}
        variant='header'
        bsPrefix='participant-integration-menu-toggle'
        className='p-1 d-flex align-items-center gap-1'
        disabled={disabled}
        aria-label={`${integrationName} actions`}
      >
        {children}
        <i className='bi bi-chevron-down paragraph-extra-small' />
      </Dropdown.Toggle>
      <Dropdown.Menu className='p-0'>
        <MenuItem icon='bi-person' title='Update Contact' description={`Update meeting information to ${integrationName} contact`} onClick={onUpdateContact} />
        <MenuItem icon='bi-play-btn' title='Manage Workflows' description={`Start and manage your ${integrationName} workflows`} onClick={onManageWorkflows} />
      </Dropdown.Menu>
    </Dropdown>
  )
}
